import React from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import { Link } from 'react-router'
import i18next from 'i18next'
import GridContainer from './GridContainer'

import buttonStyles from './styles/button.scss'
import listingStyles from './styles/listing.scss'

export default class OrganisationList extends React.Component {
  render() {
    return (
      <GridContainer>
        <Row>
          <Col md={12}>
            <header>
              <h1>{i18next.t('customer_organisations')}</h1>

              <Link
                to="/admin/organisations/new"
                className={buttonStyles.button}
                style={{ marginLeft: 20 }}
              >
                {i18next.t('new_organisation')}
              </Link>
            </header>

            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>{i18next.t('name')}</th>
                    <th>{i18next.t('notes')}</th>
                    <th>{i18next.t('wopi_credits')}</th>
                    <th>{i18next.t('wopi_360_credits')}</th>
                    <th />
                  </tr>
                </thead>

                <tbody>
                  {this.props.organisations.map(organisation => (
                    <tr
                      key={organisation.id}
                      className={
                        organisation.id === this.props.currentOrganisationId &&
                        listingStyles.selected
                      }
                    >
                      <td>
                        <Link to={`/admin/organisations/edit/${organisation.id}`}>
                          {organisation.id}
                        </Link>
                      </td>
                      <td>
                        <Link to={`/admin/organisations/edit/${organisation.id}`}>
                          {organisation.name}
                        </Link>
                      </td>
                      <td>
                        <small style={{ fontSize: 12 }}>{organisation.notes}</small>
                      </td>
                      <td>{organisation.creditsWopi}</td>
                      <td>{organisation.creditsWopi360}</td>
                      <td>
                        {organisation.id !== this.props.currentOrganisationId && (
                          <Button onClick={this.handleAdministerClick(organisation)}>
                            {i18next.t('administer')}
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </GridContainer>
    )
  }

  handleAdministerClick = organisation => e => {
    this.props.onSetCurrentOrganisation(organisation)
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganisationList.js